/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import axios from "axios";
import CryptoJs from 'crypto-js'
import { message } from "antd";
import store from "../../redux/store";
import actionWays from "../../redux/actions";
const nonce = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
const guid = (id, type) => {
    // type  2:Web端; 1:后台管理系统;
    if (!id || id == undefined) {
        id = ''
    }
    var getuid = '00000000' + id
    getuid = getuid.substring(getuid.length - 8, getuid.length)
    console.log(getuid)
    getuid = CryptoJs.enc.Utf8.parse(getuid)
    return CryptoJs.enc.Base64.stringify(getuid)
}
const getUserIp =()=>{
    return new Promise((resolve, reject) => {
        fetch('/nodes/oms/getUserIp', {
          method: 'POST',
          mode: 'cors',
          rejectUnauthorized: false,
        })
          .then((response) => response.json())
          .then((res) => {
            console.log('result', res);
            localStorage.setItem('userIp', res?.userIp);
            resolve(res?.userIp);
          })
          .catch((err) => reject(err));
      });
}
const service = axios.create({
    // headers: {
    //     'Z-timestamp':timestamp,
    //     'Z-nonce':nonceData,
    //     'Z-signature':CryptoJs.MD5(guid(store.getState().userLoginInfo?.id,'2')+'DWjfxmA12a'+timestamp+nonceData).toString(),
    //     'Authorization':guid(store.getState().userLoginInfo?.id,'2'),
    //     'ip': window.returnCitySN.cip,
    //     'uuid':guid(store.getState().userLoginInfo?.id,'2'),
    // },
    baseURL: undefined, // url = base url + request url
    timeout: 35000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    async config => {
        let timestamp = Date.now().toString()
        let nonceData = nonce()
        let userIp = localStorage.getItem('userIp')?localStorage.getItem('userIp'): await getUserIp()
        config.headers = {
            ...config.headers,
            'Z-timestamp': timestamp,
            'Z-nonce': nonceData,
            'Z-signature': CryptoJs.MD5((store.getState().userLoginInfo?.token || 1) + 'g8SzIXPkOm' + timestamp + nonceData).toString(),
            'Authorization': store.getState().userLoginInfo?.token || 1,
            'ip':  userIp,
            'userId': guid(store.getState().userLoginInfo?.id),
            'type': '4'
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        // if (res.code !== 0) {
        //     return res
        // } else {
        //     return res
        // }
        if (res.code == '-20') {
            alert("你的账户在其它设备登录")
            store.dispatch(actionWays.saveLoginInfo(null))
            window.location = "/"
            return 
        } else if (res.code == '-21') {
            alert("您的登录已过期")
            store.dispatch(actionWays.saveLoginInfo(null))
            window.location = "/"
            return 
        }else{
            return res 
        } 
        
    },
    err => {
        // console.log('err' + err) // for debug
        message.error('获取失败 状态码：' + err?.response?.status)
        return
        // return Promise.reject(err)
    }
)

export default service
